import React, { forwardRef, useState } from 'react';

import { Stack, TextField } from '@mui/material';

import { getCharacterCount, getWordCount } from '~/utils/stringUtils';

import { DynamicSectionType } from '../../context/useDynamicSections';

interface Props {
  existingText?: string;
}

export enum SCHEDULE_CUSTOM_TEXT_SECTION_FORM_NAMES {
  TEXT = 'custom_text_section_text',
}

export function parseCustomTextSectionFormData(formData: FormData, position = -1) {
  return {
    type: DynamicSectionType.CUSTOM_TEXT,
    position,
    text: String(formData.get(SCHEDULE_CUSTOM_TEXT_SECTION_FORM_NAMES.TEXT)).trim(),
  };
}

const ScheduleCustomTextSectionForm = forwardRef<HTMLFormElement, Props>((props, ref) => {
  const { existingText = '' } = props;
  const [text, setText] = useState(existingText);

  return (
    <Stack component="form" ref={ref} direction="column" spacing={2} mt={1}>
      <TextField
        fullWidth
        label="Custom Text"
        name={SCHEDULE_CUSTOM_TEXT_SECTION_FORM_NAMES.TEXT}
        value={text}
        onChange={(e) => setText(e.target.value)}
        required
        multiline
        rows={4}
        helperText={`Chars: ${getCharacterCount(text)} Words: ${getWordCount(text)}`}
        sx={{
          '& textarea': {
            resize: 'vertical',
            overflow: 'auto',
          },
        }}
      />
    </Stack>
  );
});

ScheduleCustomTextSectionForm.displayName = 'ScheduleCustomTextSectionForm';

export default ScheduleCustomTextSectionForm;
